<div class="dialog-info-container">
  <div mat-dialog-content class="content-detail">
    <div class="success-wrapper">
      <div class="success-wrapper__icon">
        <mat-icon style="color: #a5dc86">warning</mat-icon>
      </div>
      <!-- <div class="success-wrapper__txt">Creación manual de contacto</div> -->
    </div>

    <div class="info-wrapper">
      <!-- <div class="info-wrapper__content">
                <div class="info-wrapper__txt">Este contacto ya existe en las sala/s: </div>
                <ul class="info-wrapper__list">
                    <ng-container *ngFor="let room of conflicRooms">
                        <li class="info-wrapper__list__item">{{room.roomName}}</li>
                    </ng-container>
                </ul>
            </div> -->

      <!-- <div class="info-wrapper__content" *ngIf="roomsWithoutConflit && roomsWithoutConflit.length > 0">
                <div class="info-wrapper__txt">Se asignara el contacto en las siguientes sala/s:</div>
                <ul class="info-wrapper__list">
                    <ng-container *ngFor="let room of roomsWithoutConflit">
                        <li class="info-wrapper__list__item">{{room.roomName}}</li>
                    </ng-container>
                </ul>
            </div> -->

      <div class="info-wrapper__txt">
        Deberá reconectar la sala con facebook para poder responder los mensajes.
      </div>
    </div>
  </div>

  <div mat-dialog-actions class="mt-20 mat-dialog-actions mat-dialog-actions-custom">
    <button
      mat-raised-button
      type="button"
      aria-label="submit"
      (click)="matDialogRef.close()"
      class="save-button"
      style="color: white">
      Reconectar
    </button>
  </div>
</div>
